<p-card>
  <p-tabs value="0" scrollable>
    <p-tablist>
      <p-tab value="0">Mitarbeiter</p-tab>
      <p-tab value="1">Gebühren & Alter</p-tab>
      <p-tab value="2">Kontaktarten</p-tab>
      <p-tab value="3">Nationalitäten</p-tab>
      <p-tab value="4">Eigenschaften</p-tab>
      <p-tab value="5">Familienstand</p-tab>
      <p-tab value="6">Standorte</p-tab>
      <p-tab value="7">Gründe Bezugsende</p-tab>
      <p-tab value="8">Einkommensarten</p-tab>
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel value="0">
        <app-users></app-users>
      </p-tabpanel>
      <p-tabpanel value="1">
        <app-global-settings></app-global-settings>
      </p-tabpanel>
      <p-tabpanel value="2">
        <app-crud-table
          [data]="commentService.contactTypes"
          (delete)="commentService.deleteContactType($event.id)"
          (update)="commentService.updateContactType($event)"
          (create)="commentService.createContactType($event)">
        </app-crud-table>
      </p-tabpanel>
      <p-tabpanel value="3">
        <app-crud-table
          [data]="nationalityService.nationalities"
          (delete)="nationalityService.deleteNationality($event.id)"
          (update)="nationalityService.updateNationality($event)"
          (create)="nationalityService.createNationality($event)">
        </app-crud-table>
      </p-tabpanel>
      <p-tabpanel value="4">
        <app-crud-table
          [data]="characteristicService.characteristics"
          (delete)="characteristicService.deleteCharacteristic($event.id)"
          (update)="characteristicService.updateCharacteristic($event)"
          (create)="characteristicService.createCharacteristic($event)">
        </app-crud-table>
      </p-tabpanel>
      <p-tabpanel value="5">
        <app-crud-table
          [data]="familyStatusService.familyStatuses"
          (delete)="familyStatusService.deleteFamilyStatus($event.id)"
          (update)="familyStatusService.updateFamilyStatus($event)"
          (create)="familyStatusService.createFamilyStatus($event)">
        </app-crud-table>
      </p-tabpanel>
      <p-tabpanel value="6">
        <app-location></app-location>
      </p-tabpanel>
      <p-tabpanel value="7">
        <app-crud-table
          [data]="statusChangeReasonService.reasons"
          (delete)="statusChangeReasonService.deleteStatusChangeReason($event.id)"
          (update)="statusChangeReasonService.updateStatusChangeReason($event)"
          (create)="statusChangeReasonService.createStatusChangeReason($event)">
        </app-crud-table>
      </p-tabpanel>
      <p-tabpanel value="8">
        <app-crud-table
          [data]="incomeTypeService.types"
          (delete)="incomeTypeService.deleteIncomeType($event.id)"
          (update)="incomeTypeService.updateIncomeType($event)"
          (create)="incomeTypeService.createIncomeType($event)">
        </app-crud-table>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

</p-card>
